<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">
                        {{ title }}
                        <div class="clear"></div>
                    </div>
                        <preparing-component v-if="showComponent" :orderKey="orderKey"></preparing-component>

                </div>
                <page-footer></page-footer>
            </div>
        </div>
        <order-information-cart-list-modal></order-information-cart-list-modal>
    </div>
</template>

<script>
import PreparingComponent from "@/components/order/PreparingComponent.vue";
import OrderInformationCartListModal from "@/components/modal/OrderInformationCartListModal.vue";

export default {
    name: "preparingDetail",
    mixins: [],
    components: {
        PreparingComponent,
        OrderInformationCartListModal,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            title: this.$route.meta.title,
            orderKey : this.$route.params.idx,
            showComponent: true,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
    },
    watch: {
        '$route.path': {
            deep: true,
            handler: function (val, oldVal) {
                if(this.orderKey != this.$route.params.idx) {
                    this.orderKey = this.$route.params.idx;
                    this.showComponent = false;
                    this.$nextTick(() => {
                        this.showComponent = true;
                    })
                }
            }
        },
    },
}
</script>

<style scoped>

</style>
